import { Tabs } from 'antd';
import './TabComponent.scss';
import { cn } from '../../../utils/string/cn.utils';

const TabComponent = ({
  activeKey,
  defaultActiveKey,
  items,
  onChange,
  rightAction,
  leftAction,
  ...props
}) => {
  return (
    <Tabs
      {...props}
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      items={items}
      onChange={onChange}
      tabBarExtraContent={{ right: rightAction, left: leftAction }}
      className={cn(props.className)}
    />
  );
};

export default TabComponent;
